import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object, string } from "yup";
import PURCHASEIRQWaiveEscrowView from "../views/IrqWaiveEscrowView";
import StatusCheck from "../components/StatusCheck";

class BuildIrqWaiveEscrowPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            hasWaivedEscrow: string().required(),
          })}
        >
          <PURCHASEIRQWaiveEscrowView
            content={contentMap.BuildIrqWaiveEscrowPage}
            navigationsAway={customNavigationMap.BuildIrqWaiveEscrowPage}
            lookingTo="Build"
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(BuildIrqWaiveEscrowPage);
